// extracted by mini-css-extract-plugin
module.exports = {"link":"search-jobs-button_link__C_IzV"};